<template>
  <el-dialog
    :visible.sync="milestoneDialogVisible"
    class="milestone-info-dialog"
    title="单票订阅"
    width="950px"
    center
    append-to-body
    @open="onDialogOpen"
    @closed="afterDialogClosed"
  >
    <div>
      <el-form
        ref="milestoneForm"
        :model="milestoneForm"
        :validate-on-rule-change="false"
        label-width="150px"
      >
        <el-row style="width: 880px">
          <el-col style="height: 45px">
            <el-form-item label="订阅类型" :required="true">
              <el-radio-group
                v-model="milestoneForm.SubType"
                @change="radioChange"
              >
                <el-radio :label="'2'">按品名</el-radio>
                <el-radio :label="'3'">自定义</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col style="height: 45px">
            <el-form-item label="订阅主题" :required="true">
              <el-input
                v-model="milestoneForm.MailSubject"
                size="small"
                :maxlength="500"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col style="height: 45px">
            <el-form-item label="接收邮箱账号" :required="true">
              <el-input
                v-model="milestoneForm.MailTo"
                size="small"
                :maxlength="500"
                placeholder="多邮箱用逗号分隔,"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col style="height: 45px">
            <el-form-item label="抄送邮箱账号">
              <el-input
                v-model="milestoneForm.MailCC"
                size="small"
                :maxlength="500"
                placeholder="多邮箱用逗号分隔,"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col
            style="height: 45px"
            v-if="this.index === 2 || milestoneForm.SubType === '2'"
          >
            <el-form-item label="品名" :required="true">
              <el-select
                v-model="milestoneForm.GoodsName"
                filterable
                remote
                reserve-keyword
                clearable
                placeholder="请输入关键词"
                :remote-method="remoteGoodsMethod"
                :loading="loading"
              >
                <el-option
                  v-for="item in goodsList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col
            style="height: 45px"
            v-if="this.index === 3 || milestoneForm.SubType === '3'"
          >
            <el-form-item label="品名">
              <el-select
                v-model="milestoneForm.GoodsName"
                filterable
                remote
                reserve-keyword
                clearable
                placeholder="请输入关键词"
                :remote-method="remoteGoodsMethod"
                :loading="loading"
              >
                <el-option
                  v-for="item in goodsList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col style="height: 45px">
            <el-form-item label="时间" >
              <el-time-select
                v-model="milestoneForm.SendTime"
                :picker-options="{
                  start: '01:00',
                  step: '01:00',
                  end: '24:00'
                }"
                placeholder="选择时间">
              </el-time-select>
            </el-form-item>
          </el-col> -->
          <!-- <el-col style="height: 210px;">
            <el-form-item label="订阅内容" >
              <quill-editor ref="myQuillEditor"
              v-model="milestoneForm.MailBody"
              class="editor"
              :options="editorOption"
              />
            </el-form-item>
          </el-col> -->
          <el-col>
            <el-form-item label="Milestone节点" :required="true">
              <el-card style="margin: -1px">
                <div class="order-step">
                  <div
                    class="order-step-item"
                    v-for="(item, indexs) in data"
                    :key="indexs"
                  >
                    <div class="satus-name">
                      <el-checkbox
                        class="checkbox"
                        v-model="checkedItems"
                        :label="item.key"
                        >{{ '' }}</el-checkbox
                      >
                      <div v-show="indexs < data.length - 1" class="flex">
                        <div
                          style="
                            width: 120px;
                            border-top: 1px solid;
                            margin-top: 6px;
                            bordercolor: #51abc3;
                          "
                        ></div>
                      </div>
                    </div>
                    <div class="status-time">{{ item.label }}</div>
                  </div>
                </div>
              </el-card>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <template #footer>
      <div>
        <el-button
          type="primary"
          :loading="submitLoading"
          size="medium"
          style="margin-right: 8px"
          @click="submitForm"
          >提交</el-button
        >
        <el-button
          :loading="submitLoading"
          size="medium"
          @click="milestoneDialogVisible = false"
          >取消</el-button
        >
      </div>
    </template>
  </el-dialog>
</template>

<script>
import GMS_CODE from '@/assets/json/milestoneCode.json';
import { saveMilestoneMan, getMilestoneCodeList, getPortsList, getGoodsList } from '@/api/gmsTank';

// 工具栏配置
const toolbarOptions = [
  ['bold', 'italic', 'underline', 'strike'], // 加粗 斜体 下划线 删除线
  ['blockquote', 'code-block'], // 引用  代码块
  [{ header: 1 }, { header: 2 }], // 1、2 级标题
  [{ list: 'ordered' }, { list: 'bullet' }], // 有序、无序列表
  [{ script: 'sub' }, { script: 'super' }], // 上标/下标
  [{ indent: '-1' }, { indent: '+1' }], // 缩进
  // [{'direction': 'rtl'}],                         // 文本方向
  [{ size: ['small', false, 'large', 'huge'] }], // 字体大小
  [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
  [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
  [{ font: [] }], // 字体种类
  [{ align: [] }], // 对齐方式
  ['clean'], // 清除文本格式
  // ['link', 'image', 'video'] // 链接、图片
  ['link', 'image'] // 链接、图片
]

export default {
  name: 'MilestoneDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    milestoneInfo: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      index: '',
      data: [],
      checkedItems: [],
      Job_TypeId: '',
      milestoneForm: {
        MailTo: '',
        MailCC: '',
        MailSubject: '',
        MailBody: '',
        SelectMltCode: '',
        Job_TypeId: '',
        JobType: '',
        CustomerCode: '',
        CustomerName: '',
        TableName: '',
        POLName: '',
        PODName: '',
        GoodsID: '',
        GoodsName: '',
        SendTime: '',
        SubType: '',
      },
      submitLoading: false,
      editorOption: { // 编辑框操作事件
        theme: 'snow', // or 'bubble'
        placeholder: '请输入订阅内容...'
      },
      portPOLList: [],
      portPODList: [],
      goodsList: [],
      Commoditylist: [],
      list: [],
      loading: false,
    };
  },
  created() {
    this.Job_TypeId = this.milestoneInfo.Job_TypeId;
    this.index = '';
    this.getMilestoneCodeList();
    this.getPortsList();
  },
  computed: {
    milestoneDialogVisible: {
      get() {
        this.clean();
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      },
    },
  },
  methods: {
    remotePOLMethod(query) {
      if (query !== '') {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.portPOLList = this.list.filter(item => {
            return item.label.toLowerCase()
              .indexOf(query.toLowerCase()) > -1;
          });
        }, 200);
      } else {
        this.portPOLList = [];
      }
    },
    remotePODMethod(query) {
      if (query !== '') {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.portPODList = this.list.filter(item => {
            return item.label.toLowerCase()
              .indexOf(query.toLowerCase()) > -1;
          });
        }, 200);
      } else {
        this.portPODList = [];
      }
    },
    remoteGoodsMethod(query) {
      this.goodsList = [];
      if (query !== '') {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          getGoodsList({ Name: query.toLowerCase() }).then((res) => {
            const allData = res.data;
            allData.forEach((e) => {
              this.goodsList.push({
                value: e.MaterialNo,
                label: e.MaterialNameC,
              });
            });
          });
        }, 200);
      } else {
        this.goodsList = [];
      }
    },
    getMilestoneCodeList() {
      getMilestoneCodeList({ Job_TypeId: this.Job_TypeId, lang: this.$ls.get('lang') }).then((res) => {
        const allData = res.data;
        allData.forEach((e) => {
          this.data.push({
            key: e.id,
            label: e.text,
          });
        });
      });
    },
    getPortsList() {
      getPortsList({ JobType: this.milestoneInfo.JobType }).then((res) => {
        const allData = res.data;
        allData.forEach((e) => {
          this.list.push({
            value: e.SeaportCode,
            label: e.SeaportEname,
          });
        });
      });
    },
    submitForm() {
      if (this.index === '' && (this.milestoneForm.SubType === '' || this.milestoneForm.SubType === undefined)) {
        this.$message({
          message: '请选择订阅类型!',
          type: 'warning'
        });
      } else if (this.milestoneForm.MailSubject === '' || this.milestoneForm.MailSubject === undefined) {
        this.$message({
          message: '订阅主题不能为空!',
          type: 'warning'
        });
      } else if (this.milestoneForm.MailTo === '' || this.milestoneForm.MailTo === undefined) {
        this.$message({
          message: '接收邮箱账号不能为空!',
          type: 'warning'
        });
      } else if (this.milestoneForm.SubType === '2' && (this.milestoneForm.GoodsName === '' || this.milestoneForm.GoodsName === undefined)) {
        this.$message({
          message: '订阅类型为"按品名"时,品名不能为空!',
          type: 'warning'
        });
      } else if (this.checkedItems == null || this.checkedItems.length == 0) {
        this.$message({
          message: '请选择Milestone节点!',
          type: 'warning'
        });
      } else {
        this.$refs.milestoneForm.validate(async (valid) => {
          if (valid) {
            this.submitLoading = true;
            this.milestoneForm.CustomerCode = this.milestoneInfo.CustomerCode;
            this.milestoneForm.CustomerName = this.milestoneInfo.CustomerName;
            this.milestoneForm.SourceType = this.milestoneInfo.SourceType;
            this.milestoneForm.SelectMltCode = this.checkedItems.toString();
            this.milestoneForm.Job_TypeId = this.milestoneInfo.Job_TypeId;
            this.milestoneForm.JobType = this.milestoneInfo.JobType;
            this.milestoneForm.TableName = this.milestoneInfo.TableName;
            const queryData = {
              ...this.milestoneForm,
            };
            await saveMilestoneMan(queryData)
              .then((res) => {
                if (res && res.code === '200' && res.message === null) {
                  this.milestoneDialogVisible = false;
                  this.submitLoading = false;
                  this.$emit('submit');
                  this.checkedItems = [];
                  this.$message({
                    message: '提交成功',
                    type: 'success'
                  });
                } else {
                  this.$message.error(res.message);
                  this.submitLoading = false;
                }
              })
          } else {
            return false;
          }
        });
      }
    },
    async onDialogOpen() {
      this.checkedItems = [];
      if (this.milestoneInfo) {
        this.resetmilestoneForm();
        this.milestoneForm = {
          ...this.milestoneInfo,
        };
      }
      if (this.milestoneForm.SelectMltCode) {
        const milestoneCode = this.milestoneForm.SelectMltCode.split(',');
        for (let i = 0; i <= milestoneCode.length; i++) {
          if (milestoneCode[i] != '') {
            if (!this.checkedItems.includes(milestoneCode[i])) {
              this.checkedItems.push(milestoneCode[i]);
            }
          }
        }
      }
      this.$nextTick(() => {
        this.$refs.milestoneForm.clearValidate();
      });
    },
    handleClose() { },
    afterDialogClosed() {
      this.resetmilestoneForm();
      this.$refs.milestoneForm.resetFields();
    },
    resetmilestoneForm() {
      this.value = [];
      this.milestoneForm = {
        MailTo: '',
        MailCC: '',
        MailSubject: '',
        MailBody: '',
        SelectMltCode: '',
        Job_TypeId: '',
        JobType: '',
        CustomerCode: '',
        CustomerName: '',
      };
    },
    radioChange(val) {
      this.index = val;
    },
    clean() {
      this.index = '';
    }
  },
};
</script>
<style lang="less">
.order-step {
  display: flex;
  justify-content: center;
  img {
    width: 34px;
    height: 34px;
    display: inline-block;
    margin-right: 8px;
  }
  .order-step-item {
    margin-right: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .satus-name {
    text-align: center;
    margin-top: 2px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .name {
      font-size: 12px;
      font-weight: 600;
      color: #111827;
    }
    .grey-name {
      font-size: 12px;
      font-weight: 600;
      color: #9ca3af;
    }
    .circular-ring {
      width: 9px;
      height: 9px;
      background-color: #ffffff;
      border-radius: 50%;
    }
  }
  .status-time {
    font-size: 15px;
    font-weight: 500;
    color: #9ca3af;
    line-height: 30px;
    color: #51abc3;
  }
}

.milestone-info-dialog {
  .milestone-form-container {
    justify-content: center;
    width: 100%;
    .el-form-item {
      &.is-error {
        margin-bottom: 16px;
        .el-form-item__error {
          left: 16px;
        }
      }
    }
    .el-cascader {
      width: 100%;
    }
    .el-input__inner {
      max-width: 600px;
    }
  }
  .detailBox {
    border: 0px solid #000;
    margin-left: 1px;
    padding: 1px;
    .el-transfer-panel {
      width: 250px;
    }
  }
  .dianRed {
    color: #e66c68;
  }
  .el-dialog--center .el-dialog__body {
    text-align: initial;
    padding: 5px 5px 5px;
  }
  .el-dialog--center .el-dialog__footer {
    text-align: inherit;
    padding: 5px 5px 5px;
  }
  .checkbox {
    zoom: 120%;
  }
}
</style>

<style>
/************************************** 富文本编辑器 **************************************/
/** 设置富文本的高度 **/
.editor {
  line-height: normal !important;
  height: 140px;
  margin-bottom: 30px;
}
.ql-container {
  height: 140px !important;
}
/** 设置富文本的高度 **/

/** 设置工具栏中上传图片和上传视频对应的文件上传组件样式 **/
.avatar-uploader-img {
  height: 0;
}
.avatar-uploader-video {
  height: 0;
}
/** 设置工具栏中上传图片和上传视频对应的文件上传组件样式 **/

.ql-snow .ql-tooltip[data-mode='link']::before {
  content: '请输入链接地址：';
}
.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
  border-right: 0px;
  content: '提交';
  padding-right: 0px;
}
.ql-snow .ql-tooltip[data-mode='video']::before {
  content: '请输入视频地址：';
}
.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
  content: '14px';
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='small']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='small']::before {
  content: '10px';
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='large']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='large']::before {
  content: '18px';
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='huge']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='huge']::before {
  content: '32px';
}
.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
  content: '文本';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='1']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='1']::before {
  content: '标题1';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='2']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='2']::before {
  content: '标题2';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='3']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='3']::before {
  content: '标题3';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='4']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='4']::before {
  content: '标题4';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='5']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='5']::before {
  content: '标题5';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='6']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='6']::before {
  content: '标题6';
}
.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
  content: '标准字体';
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value='serif']::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value='serif']::before {
  content: '衬线字体';
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value='monospace']::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value='monospace']::before {
  content: '等宽字体';
}
/************************************** 富文本编辑器 **************************************/
</style>
